<article [id]="'comment-' + commentData$().id" class="comment" [@cardAnimation]="'in'">
  <div class="comment__header">
    <div class="comment__header-text">
      @if (commentData$().commenterName && commentData$().commenterName.trim().length !== 0) {
        <empathy-avatar [text]="commentData$().commenterName"></empathy-avatar>
      }

      <span class="fs__xs fw__600">{{ commentData$().commenterName }}</span>
    </div>
    <span class="comment__header-subtext fs__xs fw__400">{{ commentData$().commentDateTime | commentDate }}</span>
  </div>

  @if (!commentData$().sourceReferenceId) {
    <div class="comment__data">
      <div class="comment__data__header">
        <span class="comment__data__header-text fs__sm">
          @for (word of commentData$().commentText.split(' '); track word) {
            @if (word.startsWith('#')) {
              <empathy-hashtag [hashtag]="word" (clicked)="onEmitHashtag($event)"></empathy-hashtag>&nbsp;
            } @else {
              {{ word }}
            }
          }
        </span>

        @if (commentData$().resolvedInd) {
          <fa-icon [icon]="faCircleCheck" size="lg" class="comment__data__header-resolved"></fa-icon>
        } @else if (!readonly) {
          <button mat-button [color]="'primary'" class="comment__data__header-resolve fs__sm" (click)="resolveThread.emit()">Resolve</button>
        }
      </div>

      @if ((commentData$().replies && commentData$().replies.length > 0) || !commentData$().resolvedInd) {
        <div class="comment__data__actions">
          @for (reply of commentData$().replies; track reply) {
            <article class="comment__data__actions__reply">
              @if (reply.commenterName && reply.commenterName.trim().length !== 0) {
                <empathy-avatar [text]="reply.commenterName" size="sm"></empathy-avatar>
              }
              <div class="comment__data__actions__reply__content">
                <div class="comment__data__actions__reply__content__header">
                  <span class="comment__data__actions__reply__content__header-text fs__sm"> {{ reply.commenterName }} </span>
                  <span class="comment__data__actions__reply__content__header-subtext fs__sm">{{ reply.commentDateTime | commentDate }}</span>
                </div>

                <div class="comment__data__actions__reply__content__data">
                  <span class="fs__sm">
                    @for (word of reply.commentText.split(' '); track word) {
                      @if (word.startsWith('#')) {
                        <empathy-hashtag [hashtag]="word" (clicked)="onEmitHashtag($event)"></empathy-hashtag>
                      } @else {
                        {{ word }}
                      }
                    }
                  </span>
                </div>
              </div>
            </article>
          }

          @if (!readonly && !this.commentData$().resolvedInd) {
            <empathy-comment-input [formControl]="control" [icon]="faSend" (clicked)="onPostCommentReply()"></empathy-comment-input>
          }
        </div>
      }
    </div>
  } @else if (!readonly) {
    <div class="comment__new">
      <empathy-comment-input [formControl]="control" [icon]="faSend" (clicked)="onSaveComment()"></empathy-comment-input>
    </div>
  }
</article>
